export const I_OS = 'ios';
export const ANDROID = 'android';
export const UNSUPPORTED = 'unsupported';

function getUserAgent(userAgent?: string): string {
  return userAgent || navigator.userAgent || navigator.vendor;
}

function isBlackBerry(userAgent: string): boolean {
  return /blackberry|\bBB10\b|rim tablet os/i.test(userAgent);
}

function isWindowsPhone(userAgent: string): boolean {
  return /Windows Phone/i.test(userAgent);
}

function isIos(userAgent: string): boolean {
  return /\b(?:iPhone.*Mobile|iPod|iPad)/i.test(userAgent);
}

function isAndroid(userAgent: string): boolean {
  return /Android/i.test(userAgent);
}

export function isUserMobile(userAgent?: string): boolean {
  const ua = getUserAgent(userAgent);

  return isAndroid(ua) || isIos(ua) || isBlackBerry(ua) || isWindowsPhone(ua);
}

export function getMobileOS(userAgent?: string): string {
  const ua = getUserAgent(userAgent);

  switch (true) {
    case isAndroid(ua):
      return ANDROID;
    case isIos(ua):
      return I_OS;
    case isWindowsPhone(ua) || isBlackBerry(ua):
      return UNSUPPORTED;
    default:
      return undefined;
  }
}
